import React from 'react';
import { Sparkles } from 'lucide-react';

interface ModernDocHeaderProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  badge?: string;
  badgeColor?: 'blue' | 'green' | 'purple' | 'orange' | 'red';
}

const ModernDocHeader: React.FC<ModernDocHeaderProps> = ({
  title,
  description,
  icon,
  badge,
  badgeColor = 'blue'
}) => {
  const badgeColors = {
    blue: 'bg-blue-100 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300',
    green: 'bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-300',
    purple: 'bg-purple-100 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300',
    orange: 'bg-orange-100 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300',
    red: 'bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-300'
  };

  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-8 py-6">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="p-3 bg-brandColor rounded-xl text-white shadow-lg">
            {icon}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-1 flex-wrap">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              {title}
            </h1>
            <Sparkles className="w-5 h-5 text-brandColor flex-shrink-0" />
            {badge && (
              <span className={`px-2 py-1 text-xs font-medium rounded-full ${badgeColors[badgeColor]}`}>
                {badge}
              </span>
            )}
          </div>
          <p className="text-gray-600 dark:text-gray-400 text-base leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ModernDocHeader;
